import { iconUnplug } from "@kensho/icons";
import { Button, Tooltip } from "@kensho/neo";

import { useFootPedal } from "../../../hooks/use-foot-pedal";

interface FootPedalProps {
  seekMedia: (options: {
    timeSeconds: number;
    play?: boolean;
    scroll?: boolean;
  }) => void;
  currentTime: number;
  setPaused: React.Dispatch<React.SetStateAction<boolean>>;
  hasMedia: boolean;
}

export function FootPedalButton(props: FootPedalProps) {
  const { seekMedia, currentTime, setPaused, hasMedia } = props;

  const { connectDevice, disconnectDevice, connected } = useFootPedal(
    () => seekMedia({ timeSeconds: currentTime / 1000 + 3 }),
    () => seekMedia({ timeSeconds: currentTime / 1000 - 3 }),
    () => {
      if (hasMedia) setPaused((prev) => !prev);
    },
  );

  return (
    <Tooltip
      content={connected ? "Disconnect foot pedal" : "Connect foot pedal"}
      position="bottom"
    >
      <Button
        aria-label={connected ? "Disconnect foot pedal" : "Connect foot pedal"}
        icon={iconUnplug}
        intent={connected ? "default" : "primary"}
        onClick={
          connected
            ? () => {
                disconnectDevice();
              }
            : () => {
                connectDevice();
              }
        }
        minimal
      />
    </Tooltip>
  );
}
